var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"title":_vm.$t(_vm.title)}},[(_vm.vod)?_c('tvPlayIcon'):_vm._e(),(_vm.upcoming)?_c('CalendarWithClockIcon'):_vm._e(),(_vm.live)?_c('div',{staticClass:"live"},[_vm._v(" "+_vm._s(_vm.$t('Live'))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }